import { useRef } from "react";
import { motion, AnimatePresence, useInView } from "framer-motion";

const listV = {
  hidden: {},
  show: { transition: { staggerChildren: 0.06, delayChildren: 0.04 } },
  exit: { opacity: 0, transition: { duration: 0.12 } },
};

// Rows simply cascade in — a small fade + upward slide, staggered.
const rowV = {
  hidden: { opacity: 0, y: 14 },
  show: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.35, ease: "easeOut" },
  },
};

/** Middle column: the list of timeline entries, mission-log style. */
export default function EntryList({ entries, selectedId, onSelect, category }) {
  const wrapRef = useRef(null);
  const inView = useInView(wrapRef, { once: true, amount: 0.12 });

  return (
    <div className="entries" ref={wrapRef} role="listbox" aria-label="Timeline entries">
      <AnimatePresence mode="wait">
        <motion.div
          key={category}
          className="entries__list"
          variants={listV}
          initial="hidden"
          animate={inView ? "show" : "hidden"}
          exit="exit"
        >
          {entries.map((e) => (
            <motion.button
              key={e.id}
              type="button"
              role="option"
              aria-selected={selectedId === e.id}
              className={"entry" + (selectedId === e.id ? " is-active" : "")}
              onClick={() => onSelect(e.id)}
              variants={rowV}
            >
              <span className={"entry__check" + (e.current ? " entry__check--current" : "")} aria-hidden="true">
                {e.current ? "◒" : "✓"}
              </span>
              <span className="entry__body">
                <span className="entry__title">{e.title}</span>
                <span className="entry__meta">
                  {e.org} · {e.start}
                </span>
              </span>
              <span className={"pill " + (e.current ? "pill--cyan" : "pill--gold")}>
                {e.current ? "Current" : "Complete"}
              </span>
            </motion.button>
          ))}
        </motion.div>
      </AnimatePresence>
    </div>
  );
}
